import { useTranslation } from 'react-i18next'

interface AdminPaginationProps {
  page: number // 0-based
  totalPages: number
  onChange: (page: number) => void
}

export function AdminPagination({ page, totalPages, onChange }: AdminPaginationProps) {
  const { t } = useTranslation(['admin'])
  if (totalPages <= 1) return null
  const current = page + 1
  return (
    <nav className="flex items-center justify-center gap-3 py-4" aria-label={t('admin:students.pagination.label')}>
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 0}
        className="px-3 py-1 rounded border text-sm disabled:opacity-40 disabled:cursor-not-allowed"
      >
        {t('admin:students.pagination.prev')}
      </button>
      <span className="text-sm text-gray-600">
        {t('admin:students.pagination.pageInfo', { current, total: totalPages })}
      </span>
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={current >= totalPages}
        className="px-3 py-1 rounded border text-sm disabled:opacity-40 disabled:cursor-not-allowed"
      >
        {t('admin:students.pagination.next')}
      </button>
    </nav>
  )
}
